import { AppProviders } from '@/app/providers';
import { AppShell } from '@/ui/layout/AppShell';

export function App() {
  return (
    <AppProviders>
      <AppShell />
    </AppProviders>
  );
}
